import { defineComponent, h } from 'vue';
import { ItemProps } from '@/ui/components/inspectionReport/types';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';

export const NumberQuestion = defineComponent<ItemProps>({
  name: 'NumberQuestion',
  props: ['item'],
  setup(props) {
    return function render() {
      return h('div', {
        class: 'inspection-report__response-number',
      }, [
        props.item.responded
          ? (props.item.response as string)
          : useInspectionReport().getNotRespondedAnswer(),
      ]);
    };
  },
});
